import * as React from 'react'

import { env } from '@/shared/config/env'
import { resolveStorageUrl } from '@/shared/domain'

type StorageImageProps = Omit<React.ComponentProps<'img'>, 'alt'> & {
  alt: string
}

function StorageImage({ src, alt, ...props }: StorageImageProps) {
  return <img src={resolveStorageUrl(src, env.supabaseUrl)} alt={alt} {...props} />
}

export { StorageImage }
